import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {NetworkFilter} from 'domain/usecases/private/guide-flow/medical-guide/get-network-filters';
import {getNetworkFilters} from '../../services/getNetworkFilters';

export function useNetworkFiltersGuideQuery(options?: Partial<UseQueryOptions<NetworkFilter[]>>) {
	return useQuery<NetworkFilter[]>({
		queryKey: [QUERY_KEYS.NETWORK_FILTERS_GUIDE],
		queryFn: () => getNetworkFilters(),
		enabled: true,
		...options,
	});
}
